import { create } from 'zustand';
import {
  DashboardCardDataType,
  DashboardType,
  fetchDashboardCards,
  FetchDashboardCardsRequest,
  fetchDashboardData,
  FetchDashboardDataRequest,
} from './api/dashboard-api';

interface Store {
  fetchDashboardData: (params: FetchDashboardDataRequest) => Promise<void>;
  fetchDashboardCards: (params: FetchDashboardCardsRequest) => Promise<void>;
  list?: Record<DashboardType, unknown>;
  cards?: DashboardCardDataType;
  isLoading?: boolean;
}

export const useDashboardStore = create<Store>((set, get) => ({
  fetchDashboardData: async (params) => {
    set({ isLoading: true });
    try {
      const response = await fetchDashboardData(params);
      const updated = get().list || response;
      Object.keys(response).forEach((key) => {
        updated[key as DashboardType] = response[key as DashboardType];
      });
      set((store) => ({ ...store, list: { ...store.list, ...response } }));
    } catch (e) {
      console.error(e);
    } finally {
      set({ isLoading: false });
    }
  },
  fetchDashboardCards: async (params) => {
    set({ isLoading: true });
    try {
      const response = await fetchDashboardCards(params);
      set((store) => ({ ...store, cards: response }));
    } catch (e) {
      console.error(e);
    } finally {
      set({ isLoading: false });
    }
  },
}));
